export default class ContactForm {
  name: string;
  surname: string;
  email: string;
  phone?: string;
  message?: string;

  constructor(entity: ContactForm) {
    this.name = entity.name;
    this.surname = entity.surname;
    this.email = entity.email;
    this.phone = entity.phone || undefined;
    this.message = entity.message || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/ContactForm.tsx